module.exports = __webpack_public_path__ + "static/img/excel.b2ecbc7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/excel.jpg
// module id = F+KA
// module chunks = 171